"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;
exports.default = NotificationsWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _flyout = _interopRequireDefault(require("@ux/flyout"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _shapes = _interopRequireDefault(require("./shapes"));
var cache = _interopRequireWildcard(require("./cache"));
var _utils = require("./utils");
var _badge = _interopRequireDefault(require("./badge"));
var _list = _interopRequireDefault(require("./list"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

/**
 * Render Notification component.
 * When clicked it will open up a dropdown with notifications.
 * Clicking on a notification in dropdown will transfer you to the notifications link.
 *
 * @class Notifications
 * @public
 *
 * @returns {React.ReactElement} Notification component
 */

class Notifications extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.openList = this.openList.bind(this);
    this.closeList = this.closeList.bind(this);
    this.toggleList = this.toggleList.bind(this);
    this.generateEid = this.generateEid.bind(this);
    this.notesSeenLogImpressions = (0, _memoizeOne.default)(this.notesSeenLogImpressions.bind(this));
    this.logBellClickEid = this.logBellClickEid.bind(this);
    this.logBellImpressionEid = this.logBellImpressionEid.bind(this);
    this.getNotifications = this.getNotifications.bind(this);
    this.outside = this.closeList;
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Opens notification dropdown list.
   *
   * @private
   * @param {event} event React Synthetic event for Click.
   *
   */

  openList(event) {
    event.preventDefault();
    const {
      endpoint,
      shopperId,
      market
    } = this.props;
    cache.requestNotifications({
      href: endpoint.href,
      shopperId: shopperId,
      market: market,
      successCb: function notifRequestSuccess(response) {
        if (!this._isMounted) return;
        const {
          notifications
        } = response;
        this.setState({
          isLoaded: true,
          notifications: !this.state.notification || !(0, _utils.arraysEqual)(notifications, this.state.notifications) ? notifications : this.state.notifications
        });
        this.logBellImpressionEid();
      }.bind(this),
      errorCb: function notifRequestFailed(error) {
        if (!this._isMounted) return;
        this.setState({
          error,
          isLoaded: true
        });
      }.bind(this)
    });
    const {
      isLoaded
    } = this.state;
    if (!isLoaded || !this._isMounted) {
      return;
    }
    this.setState({
      isOpen: true
    }, () => {
      this.logBellClickEid();
      this.notesSeenLogImpressions();
      this.props.onOpen();
    });
  }

  /**
   * Closes notification dropdown list.
   *
   * @private
   */

  closeList() {
    const {
      isLoaded
    } = this.state;
    if (!isLoaded || !this._isMounted) {
      return;
    }
    this.setState({
      isOpen: false
    });
  }

  /**
   * Toggles open/close state of notification dropdown list.
   *
   * @param {event} e React Synthetic event for click.
   * @private
   */

  toggleList(e) {
    e.stopPropagation();
    const {
      isOpen
    } = this.state;
    const {
      openList,
      closeList
    } = this;
    isOpen ? closeList() : openList(e);
  }

  /**
   * Generate unique Eid.
   *
   * @param  {string} suffix Value appended to Eid.
   * @returns {string} Full EID
   *
   * @private
   */

  generateEid(suffix) {
    const manifest = this.props.manifest.toLowerCase();
    return `uxp.hyd.${manifest}.${suffix}`;
  }

  /**
   * Get notification data
   *
   * @returns {Object} notifications and unviewedNotifications
   *
   * @private
   */

  getNotifications() {
    const notifications = [...(this.state.notifications || []), ...(this.props.notifications || []), ...(this.props.customNotifications || [])];
    const unviewedNotifications = notifications.some(notification => !notification.viewed);
    return {
      notifications,
      unviewedNotifications
    };
  }

  /**
   * Logs traffic IMPRESSION with each notification's impression EID.
   *
   * @private
   */

  notesSeenLogImpressions() {
    const {
      notifications = []
    } = this.state;
    const expDataLayer = window._expDataLayer = window._expDataLayer || [];
    notifications.forEach(_ref => {
      let {
        eids = {}
      } = _ref;
      eids.impression && expDataLayer.push({
        schema: 'add_event',
        version: 'v2',
        data: {
          eid: eids.impression,
          type: 'impression'
        }
      });
    });
  }

  /**
   * Logic to select EID based on notification seen, unseen, or empty status.
   *
   * @private
   */

  eidSelection() {
    const {
      notifications,
      unviewedNotifications
    } = this.getNotifications();
    const {
      eids
    } = this.props;
    if (eids && eids.emptyBell) {
      // eid if there are 0 notifications
      let bellStatusEid = eids.emptyBell;
      if (unviewedNotifications) {
        // eid if there are any notifications that are unseen
        bellStatusEid = eids.unseenBell;
      } else if (notifications.length) {
        // eid if there are notifications that are seen, but none unseen.
        bellStatusEid = eids.seenBell;
      }
      return bellStatusEid;
    }
  }

  /**
   * Logs traffic CLICK with Eid. Manifest "applicationsidebar" Eid depends on whether there are notifications
   * and whether they have been seen.
   *
   * @private
   */

  logBellClickEid() {
    const eid = this.generateEid('notifications_bell.click');
    const expDataLayer = window._expDataLayer = window._expDataLayer || [];
    // @ts-expect-error
    expDataLayer.push({
      schema: 'add_event',
      version: 'v2',
      data: {
        eid: eid,
        type: 'click'
      }
    });
    const bellStatusEid = this.eidSelection();
    if (bellStatusEid) {
      expDataLayer.push({
        schema: 'add_event',
        version: 'v2',
        data: {
          eid: bellStatusEid.click,
          type: 'click'
        }
      });
    }
  }

  /**
   * Logs traffic IMPRESSION with each badge render. Manifest "applicationsidebar" eid depends on whether there are notifications
   * and whether they have been seen.
   *
   * @private
   */

  logBellImpressionEid() {
    const eid = this.generateEid('notifications_bell.impression');
    const expDataLayer = window._expDataLayer = window._expDataLayer || [];
    expDataLayer.push({
      schema: 'add_event',
      version: 'v2',
      data: {
        eid: eid,
        type: 'impression'
      }
    });
    const bellStatusEid = this.eidSelection();
    if (bellStatusEid) {
      expDataLayer.push({
        schema: 'add_event',
        version: 'v2',
        data: {
          eid: bellStatusEid.impression,
          type: 'impression'
        }
      });
    }
  }
  componentDidMount() {
    const props = this.props;
    const {
      endpoint,
      shopperId,
      market
    } = props;
    cache.requestNotifications({
      href: endpoint.href,
      shopperId: shopperId,
      market: market,
      successCb: function notifRequestSuccess(response) {
        if (!this._isMounted) return;
        const {
          notifications
        } = response;
        this.setState({
          isLoaded: true,
          isOpen: false,
          notifications
        });
        this.logBellImpressionEid();
      }.bind(this),
      errorCb: function notifRequestFailed(error) {
        if (!this._isMounted) return;
        this.setState({
          error,
          isLoaded: true
        });
      }.bind(this)
    });
  }

  /**
   * Renders 'pointer' caret on top of Notification dropdown box.
   *
   * @returns {React.ReactElement} Caret and div with className
   * @private
   */

  renderCaret() {
    return this.props.showOpenCaret && /*#__PURE__*/_react.default.createElement("div", {
      className: "caret"
    });
  }

  /**
   * Renders Notification list dropdown menu.
   *
   * @returns {React.ReactElement} NotificationList
   * @private
   */

  renderNotificationList() {
    const {
      closeList
    } = this;
    const {
      sso,
      messages
    } = this.props;
    const {
      error
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderCaret(), /*#__PURE__*/_react.default.createElement(_list.default, {
      error: error,
      notifications: this.getNotifications().notifications,
      messages: messages,
      sso: sso,
      closeList: closeList
    }));
  }

  /**
   * Renders Notification bell icon.
   *
   * @returns {React.ReactElement} NotificationBadge
   * @public
   */

  render() {
    const {
      toggleList
    } = this;
    const {
      className,
      sso,
      messages,
      tooltip,
      containerRef
    } = this.props;
    const {
      isOpen,
      isLoaded
    } = this.state;
    const {
      notifications,
      unviewedNotifications
    } = this.getNotifications();
    const classes = (0, _classnames.default)(className, 'notifications', {
      'open': isOpen,
      'loaded': isLoaded,
      'has-notifications': notifications && notifications.length > 0 && sso
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: containerRef,
      className: classes,
      onClick: toggleList
    }, /*#__PURE__*/_react.default.createElement(_badge.default, {
      isOpen: isOpen,
      messages: messages,
      unviewedNotifications: unviewedNotifications,
      tooltip: tooltip
    }), isOpen && /*#__PURE__*/_react.default.createElement(_flyout.default, {
      className: 'notifications-flyout',
      anchorRef: containerRef,
      placement: "bottom-end"
    }, this.renderNotificationList()));
  }
}

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
exports.Notifications = Notifications;
Notifications.defaultProps = {
  showOpenCaret: false,
  onOpen: () => null,
  customNotifications: []
};

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

Notifications.propTypes = {
  /** Header name */
  manifest: _propTypes.default.string.isRequired,
  /** Custom Notifications coming in via addCustomNotification endpoint */
  customNotifications: _propTypes.default.arrayOf(_propTypes.default.object),
  /** API endpoint to get href */
  endpoint: _propTypes.default.shape({
    href: _propTypes.default.string.isRequired
  }),
  /** Notification EIDs for clicks and impressions */
  eids: _propTypes.default.object,
  /** Single sign on login.href */
  sso: _shapes.default.sso.isRequired,
  /** ID to identify Private Labels (1 is GoDaddy) */
  privateLabelId: _propTypes.default.number,
  /** Individual shopper ID */
  shopperId: _propTypes.default.string,
  /** Market code */
  market: _propTypes.default.string.isRequired,
  /** Notification strings with translations */
  messages: _shapes.default.messages.isRequired,
  /** Notifications from other datasources */
  notifications: _propTypes.default.arrayOf(_shapes.default.notification),
  /** Custom classnames  */
  className: _propTypes.default.string,
  /** String in notificationBadge used as "roll over text" for button */
  tooltip: _propTypes.default.string,
  /** Boolean to display dropdown 'pointer' */
  showOpenCaret: _propTypes.default.bool,
  /** Provides same object every render */
  containerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Callback executed when the user opens the notifications flyout */
  onOpen: _propTypes.default.func
};
function NotificationsWrapper(props) {
  const instanceRef = (0, _react.useRef)();
  const containerRef = (0, _react.useRef)();
  (0, _componentUtilities.useOnClickOutside)(containerRef, () => {
    // @ts-ignore
    typeof instanceRef.current.outside === 'function' && instanceRef.current.outside();
  });
  return /*#__PURE__*/_react.default.createElement(Notifications, (0, _extends2.default)({}, props, {
    containerRef: containerRef,
    ref: instanceRef
  }));
}